// extracted by mini-css-extract-plugin
export default {"cls1":"WUBSPaymentReceipt-Paragraph_cls1__CN9YF","cls2":"WUBSPaymentReceipt-Paragraph_cls2__6xDFy WUBSPaymentReceipt-Paragraph_cls1__CN9YF"};